import React from 'react'
import payme from "../images/paymelogo.svg";
import finvo from "../images/finvu.svg";
export default function JointLogo() {
  return (
    <div className='jointlogo' >
    <img src={payme}></img>
    <img className='finvologo' src={finvo} ></img>    
    </div>
  )
}
